import { getScoreList, postScore, postSingleScoringEvaluation, updateScoringEvaluation } from "@/services/score.service";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Puanlama Öğrenci Listesi
  async loadScoringList(vuexContext, co) {
    return await getScoreList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;

        // item[1]=20;
        // item[2]=20;
        // item[3]=21;
        // item[4]=10;

        item.userStudentClassDtos.forEach((scoringType) => {
          item[scoringType.scoringTypeId] = scoringType.score;
          if (scoringType.failedFromClass === true) {
            item.failedFromClass = true;
            item.failedScoreType = scoringType.scoringTypeName;
          }
        });
      });
      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async postScore(vuexContext, data) {
    return await postScore(data);
  },

  async postSingleScoringEvaluation(vuexContext, data) {
    return await postSingleScoringEvaluation(data);
  },

  async updateScoringEvaluation(vuexContext, data) {
    return await updateScoringEvaluation(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
